import { useCallback, useMemo, useState } from 'react';
import SearchableCombobox from '../SearchableCombobox';
import Spinner from '../Spinner';

const BannerSelector = ({ banners, bannerId, onSelect }) => {
  const [dirty, setDirty] = useState(false);

  const options = useMemo(
    () =>
      (banners || []).map((f) => ({
        value: f.id.toString(),
        label: f.name,
      })),
    [banners]
  );

  const handleChange = useCallback(
    (value) => {
      setDirty(true);
      onSelect(banners.find((f) => f.id.toString() === value));
    },
    [banners, onSelect]
  );

  const handleBlur = useCallback(() => setDirty(true), []);

  if (!banners) {
    return <Spinner />;
  }

  return (
    <>
      <SearchableCombobox
        options={options}
        onBlur={handleBlur}
        onChange={handleChange}
        value={bannerId?.toString()}
      />
      {dirty && !bannerId && <small style={{ color: 'var(--mantine-color-red-6)' }}>Banner is required</small>}
    </>
  );
};

export default BannerSelector;
